import { Box, Divider, Flex, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, useMediaQuery } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { ActivityTable } from './style';
import MorePanel from '../../../Component/MorePanel';
import { theme } from '../../../assets/style/theme';

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
  data:any;
  category:string;
};

function ParticipationContentItemActivityTab({ data, category }: Props) {
  const [tabIndex, setTabIndex] = useState(0);

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <>
    <Tabs orientation={isMobile ? 'horizontal' : 'vertical'} variant='unstyled' colorScheme='dgr' onChange={(index) => setTabIndex(index)}>
      <TabList pt="5" pr="5" w={participationSideBoxWidth} >
        {
          data.map((item: any, index: number) => (
            <Tab mb="4" pl="0" textAlign="left" display="block" >
              <Heading size={isMobile ? '2xl' : '4xl'} color={index === tabIndex ? 'b.dgr' : 'b.lg'} >{item.title}</Heading>              
            </Tab>
          ))
        }
      </TabList>

      <TabPanels w={participationContentBoxWidth} p={0}>
        {
          data.map((item: any) => (
            <TabPanel p={0}>
              <ActivityTable>
                <MorePanel maxHeight={950}>
                  <>
                    <div dangerouslySetInnerHTML={ {__html: item.content} } />
                  </>
                </MorePanel>
              </ActivityTable>
            </TabPanel>
          ))
        }
      </TabPanels>
    </Tabs>
    </>
  );
}

ParticipationContentItemActivityTab.defaultProps = {
};

export default ParticipationContentItemActivityTab;
